import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFirstPartnerOfferingsCatalog = createSelector(
  [selectFinancialCockpitState],
  ({ offeringsCatalog }) => offeringsCatalog[0]?.offerings ?? []
)
